import {cn} from '@containers/html-utils'
import React from 'react'
import {TextInput} from '../text-input/text-input'
import {TextInputProps} from '../text-input/types'

export interface LabeledInputProps extends TextInputProps {
  label: React.ReactNode
  inputClassName?: string
}

export const LabeledInput = (props: LabeledInputProps) => {
  const {label, className, inputClassName, ...inputProps} = props
  return (
    <label
      className={cn(
        'text-secondary-old',
        props.large ? 'text-14' : 'text-12',
        className
      )}
    >
      {label}
      <TextInput {...inputProps} className={inputClassName} />
    </label>
  )
}
